module.exports = __webpack_public_path__ + "static/media/DIG.ecf5857f.png";